import { BEDRIVE_CONFIG } from './bedrive-config';
var ɵ0 = BEDRIVE_CONFIG;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
